<template>
  <div class="no-feed-wrapper center-xy">
    <i class="n-i" :class="`n-i-${gameId}`"></i>
    <div class="no-feed-message">{{'noOffer' | translate}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import isEqual from 'lodash/isEqual';
import gateway from '../services/gateway';

export default {
  name: 'NoFeed',
  computed: {
    ...mapGetters([
      'gameId',
      'offer',
    ]),
  },
  methods: {
    goToBettingRoute() {
      gateway.sendMessage('Widget.UpdateSettings', {
        gamesHelp: {
          show: true,
        },
        calculator: {
          show: true,
        },
        ticketSession: {
          show: true,
        },
        ticketList: {
          show: true,
        },
      });
      this.$router.push({ path: 'betting' });
    },
  },
  mounted() {
    if (Object.keys(this.offer).length) {
      this.goToBettingRoute();
    }
  },
  watch: {
    offer: {
      handler(newOffer, oldOffer) {
        console.log('WATCH OFFER', newOffer, oldOffer);
        if (isEqual(newOffer, oldOffer)) {
          this.goToBettingRoute();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  i {
    font-size: 5rem;
  }
  .no-feed-wrapper {
    opacity: .3;
    text-align: center;
  }
</style>
